import { useEffect, useState } from 'react'
import axios from '../util/Axios';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as actions from '../store/actions/GlobalActions';
import Header from '../components/Header';
import { Paper, Button } from '@mui/material';

function ValidateMFA() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [error, setError] = useState(false);

  useEffect(() => {
    const paramsString = window.location.search;
    const searchParams = new URLSearchParams(paramsString);
    const state = searchParams.get("state");
    const duoCode = searchParams.get("duo_code");

    if (!state || !duoCode) {
      setError(true);
      return;
    };

    axios
      .post('/users/validate-duo-mfa', {
        duoCode,
        state,
      })
      .then((data) => {
        dispatch({
          type: actions.LOGIN,
          payload: { user: data.data.user, auth: data.data.authToken },
        });
        navigate('/', { replace: true });
      })
      .catch(() => {
        setError(true)
      });
  }, [dispatch, navigate])

  const formControl = {
    width: '80%',
    margin: 'auto',
    marginTop: '16px',
    marginBottom: '16px',
    height: '45px',
    textAlign: 'center',
  };

  return (
    <div>
      <Header logged={false} />
      <Paper
        sx={{
          width: { sx: '300px', sm: '600px' },
          margin: 'auto',
          marginTop: '160px',
          display: 'flex',
          alignContent: 'center',
          flexDirection: 'column',
          textAlign: 'center'
        }}
      >
        { error ?
          <>
            <p>Authentication failed!</p>
            <p>Please return to login.</p>
            <Button sx={formControl} variant="contained" color="primary" onClick={() => navigate('/login', { replace: true })}>
              Login
            </Button>
          </>
          :
          <p>Authenticating ...</p>
        }
      </Paper>
    </div>
  )
}

export default ValidateMFA